<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="mb-0 font-medium text-uppercase">Templates Managers <span
              class="badge badge-primary">{{ count }}</span></h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
            <ol class="p-0 mb-0 breadcrumb justify-content-end">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Templates Managers</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-6">
                  <label for="slug">Search by template name</label>
                  <div class="input-group">
                  <span class="input-group-btn">
                    <button class="btn waves-effect waves-light btn-info" type="button">
                      <i class="fa fa-search"></i>
                    </button>
                  </span>
                    <input
                        v-model="textSearch"
                        class="form-control"
                        placeholder="Search by name"
                        type="text"
                        @change="searchPresentation()"
                    />
                  </div>
                </div>
                <div class="form-group col-6">
                  <label for="slug">AhaSlides picks</label>
                  <div class="input-group">
                    <select v-model="filters.isAdminPick" class="form-control" @change="filter()">
                      <option value="">All</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="text-center">
                  <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                </div>
                <table class="table">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Access Code</th>
                    <th>Copy count</th>
                    <th>Slide count</th>
                    <th>AhaSlides Pick</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="(item, index) in items"
                      :key="index"
                      class="pointer"
                      @click="openDetailTemplate(item)"
                  >
                    <td @click.stop="handleCellClick(item.id, 'ID')">{{ item.id }}</td>
                    <td>{{ item.name }}</td>

                    <td>{{ item.accessCode }}</td>
                    <td>{{ item.copyCount }}</td>
                    <td>{{ item.slideCount }}</td>
                    <td>
                      <input v-model="item.isAdminPick" name="isAdminPick" type="checkbox"
                             @click.stop="patchTemplate('isAdminPick', item, index)">
                    </td>
                  </tr>
                  </tbody>
                </table>

                <div class="overflow-auto">
                  <b-pagination v-model="page" :total-rows="count" :per-page="perPage"></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Config from "@/config"
import backdoor from '@/services/backdoor'

export default {
  name: "Templates",
  data() {
    return {
      items: [],
      page: 1,
      count: 0,
      isLoading: false,
      perPage: 30,
      textSearch: "",
      filters: {
        isAdminPick: '',
      },
    }
  },
  created() {
    this.getData()
  },
  mounted() {
  },
  watch: {
    page: {
      handler: function () {
        this.getData()
      },
      deep: true
    }
  },
  methods: {
    searchPresentation() {
      this.getData()
    },
    filter() {
      this.getData()
    },
    searchUser() {
      this.getData()
    },
    getFilterData() {
      const filters = {}
      Object.keys(this.filters).forEach((keyFilter) => {
        if (this.filters[keyFilter] !== '') {
          filters[keyFilter] = this.filters[keyFilter]
        }
      })
      return filters
    },
    async callApiUpdatePresentation(id, payload) {
      try {
        return await this.$http
            .patch(`${Config.api.adminPatchPresentationDetail}${id}`, payload)
      } catch (e) {
        console.log(e)
        return false
      }
    },
    async patchTemplate(property, item, index) {
      const payload = {}
      payload[property] = !item[property]
      const res = await this.callApiUpdatePresentation(item.id, payload)
      if (!res) {
        this.$toasted.error('Update template error!', {duration: 10000})
        this.items[index][property] = !payload[property]
        return false
      }
      this.$toasted.success('Update template success!', {duration: 500})
      return true
    },
    getData() {
      this.isLoading = true
      let params = {
        filters: this.getFilterData(),
        page: this.page,
        limit: this.perPage,
      }
      if (this.textSearch) {
        params.textSearch = this.textSearch
      }
      this.$http
          .get(Config.api.adminGetTemplates, {
            params: params
          })
          .then(res => {
            this.items = res.body.presentations.sort((a, b) => {
              return b.copyCount - a.copyCount
            })
            this.count = res.body.total
            this.isLoading = false
          })
    },
    openDetailTemplate(item) {
      this.$router.push({name: "TemplateDetail", params: {id: item.id}})
    },

    async goToPresenterSide(item) {
      if (item.isLoading) return
      item.isLoading = true
      try {
        await backdoor.openPresenterAs(item.id)
      } finally {
        item.isLoading = false
      }
    },
    handleCellClick(data, cellName) {
      // Check if any text is selected; if so, do not trigger the click action.
      if (window.getSelection().toString().length > 0) {
          return
      }

      switch (cellName) {
        case 'ID':
          this.goToPublicTemplate(data)
          break
        default:
          break
      }
    },
    goToPublicTemplate(id) {
      window.open(`${Config.publicTemplateUrl}/p/${id}/`, "_blank")
    },
  }
}
</script>
<style lang="scss" scoped>
// .addUser-btn {
//   background-color: #4f9af2;
//   border-radius: 20px;
//   border-color: #4f9af2;
//   &:hover {
//     background-color: #2785f0;
//     border-color: #2785f0;
//   }
// }
</style>
